<template>
  <span v-stat:click="{action:'ZNZT_2023chick_03',extend:{
    hotspotId,
    typeId,
    seriesId,
    specId
  }}"
  v-stat:show="{action:'ZNZT_2023show_02',extend:{
    hotspotId,
    typeId,
    seriesId,
    specId
  }}" class="hot-dot" :title="salesInfo" @click="openCarPic(typeId,seriesId,specId)">
</span>
</template>
<script>
import { staticIdProxy, actionProxy } from '@/services/socketIO/user.action.interceptor';
import layManager from '@/services/layer.manager';
import * as LayerNames from '../../../layerName';
export default {
  data () {
    return {
      vInnerText: null,
      vUnit: '',
      vDownPrice: 0, //直降价格
      funShow: false, //详细配置隐藏
      funAnimation: false, //详细配置动效class控制
      distance: 0,
      scale: 1,
      translateX: 0,
      translateY: 0,
    };
  },
  props: {
    hotspotId: { type: [Number, String], default: 0 },
    typeId:{ type:Number, default:0},
    seriesId: { type: Number, default: 0 },
    seriesName: { type: String, default: '' },
    specId: { type: Number, default: 0 },
    specName: { type: String, default: '' },
    downPrice: { type: Number, default: 0 },
    score: { type: Number, default: 0 },
    salesInfo: { type: String, default: '' },
    has3d: { type: Boolean, default: false },
    sceneName: { type: String, default: '' },
    facRebateAmount: { type: Number, default: 0 },
    jumpUrl: { type: String, default: '' },
    position: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  created: staticIdProxy(function () {
    return;
  }, 'dot'),
  methods: {
    openCarPic: actionProxy('openCarPic', function (typeId,seriesId,specId) {
      layManager.open(LayerNames.SPEC_DOT_LAYER, {
      propsData: {
        displayTypeId: 1,
        layerName: LayerNames.SPEC_DOT_LAYER,
        typeId: typeId,
        seriesId: seriesId,
        specId: specId
      }
      });
    }),
  },
};
</script>
<style scoped>
.hot-dot {
  background-image: url(../../../../assets/img/vr-point.png);
  background-size: cover;
  width: 3rem;
  height: 3rem;
  display: block;
}
</style>
